import React from 'react';
import _ from 'underscore';
import { translate } from 'react-i18next';
import { Segment, Card, Grid, Icon, Button, Message } from 'semantic-ui-react';

import Utils from 'utils/Utils.js';
import CategoryUtils from 'utils/CategoryUtils.js';
import {colors, spacings, shadowLight, fonts} from 'style';

var style = {
    content: {
        position:'relative',
        width: '100%',
        ...fonts.body,
    },
    categoryIconSpacer: {
        float: 'right',
        display: 'inline-block',
        width: spacings.small,
    },
    categoryIconCenter: {
        marginTop: spacings.tiny,
        marginLeft: spacings.tiny,
        marginRight: spacings.tiny,
        display: 'inline-block',
        height: '26px',
        width: '26px',
        cursor: 'pointer',
    },
    categoryBadge: {
        margin: spacings.small,
        height: '34px',
        width: '34px',
    },
    logged: {
        textAlign: 'center',
        color: colors.themeTeal,
        padding: spacings.large,
    },
    loggedText: {
        padding: spacings.small,
        ...fonts.h3
    },
    grid: {
        padding: spacings.base,
    },
    card: {
        cursor: 'pointer',
        border: 'none',
        boxShadow: shadowLight,
        overflow:'hidden',
        color: colors.themeDarkerGrey,
        textAlign: 'center',
        borderRadius: '9px',
        ...fonts.bodyL
    },
    pseudoCard: {
        height: '0px',
        minHeight: '0px',
        border: 'none',
        boxShadow: 'none',
        visibility: 'hidden',
        marginTop: '0',
        marginBottom: '0',
    },
    footer: {
        marginTop: spacings.small,
        color: '#fff',
        ...fonts.h2
    }

};


const LogCards = ({t,
                  avatarUrl,
                  open,
                  hide,
                  saving,
                  saved,
                  inline,
                  inputText,
                  categories,
                  selectedCategory,
                  onLaunch,
                  onChange,
                  onSelectCategory,
                  children}) => (
    <div style={{...style.content, ...(hide && {visibility: 'hidden'})}}>



        <Grid columns='equal' centered style={style.grid}>
            {categories.map((category) => (
                <Grid.Column key={category.id}>
                    <div style={{...style.card, color:(CategoryUtils.getCategoryColor(category.tag) || colors.themeDarkerGrey)}} 
                         key={category.id}
                         onClick={()=>onSelectCategory(category)}>
                         <div>
                             {category.badge &&
                                 <img style={style.categoryBadge} alt='' src={category.badge.url}></img>
                             }
                             <div>{category.title}</div>
                         </div>
                         <div style={{...style.footer, backgroundColor:(CategoryUtils.getCategoryColor(category.tag) || colors.themeDarkerGrey)}}>
                            +
                         </div>
                    </div>
                </Grid.Column>
                )
            )}
        </Grid>

        {children}
    </div>
);
export default translate('logs')(LogCards);



// WEBPACK FOOTER //
// ./src/modules/logs/LogCards.js